export const initialToggleHeader = {
  name: false,
  description: false,
  UploadedBy: false,
  UploadedDate: false,
  DownloadedBy: false,
  DownloadedDate: false,
  ChangedBy: false,
  ChangedDate: false,
  version: false,
  type: false,
  size: false,
};

export const headerFilterFields = {
  name: "Name",
  description: "Description",
  UploadedBy: "UploadedBy",
  UploadedDate: "UploadedDate",
  DownloadedBy: "DownloadedBy",
  DownloadedDate: "DownloadedDate",
  ChangedBy: "ChangedBy",
  ChangedDate: "ChangedDate",
  version: "VersionNo",
  type: "Type",
  size: "Size",
};
